import store from "@/store";

export function hasVehicleInfo() {
    return (
        store.getters.order?.vehicle.year &&
        store.getters.order?.vehicle?.make &&
        store.getters.order?.vehicle?.model &&
        store.getters.order?.vehicle?.style &&
        store.getters.order?.vehicle?.carId
    );
}
